module.exports = __webpack_public_path__ + "static/desktop/img/material-8.768b968f.jpg";